'use strict';

angular.module('clientDashboardApp').service('locationGroupService', ['$q','$http',function ($q, $http) {

  return {
    getLocationGroups: function () {
    return $http.get('/admin/group/all');
    }
  }
}]);
